<template>
	<div class="d-flex">
		<template v-for="star in 5">
			<v-icon v-if="star <= quality" class="orange--text">
				mdi-star
			</v-icon>

			<v-icon v-else>
				mdi-star-outline
			</v-icon>
		</template>
	</div>
</template>

<script>
export default {
	name: "Quality",

	props: ["quality"],

	data() {
		return {};
	},
};
</script>

<style lang="css" scoped></style>
